/**
 * @flow
 * @relayHash 56ca5d1982adf3634d79dd7d025c9b7b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POGenerationTriggerType = "LOW_STOCK" | "ORDER_REQUIREMENT";
export type POStatus = "APPROVED" | "CANCELLED" | "PARTIALLY_RECEIVED" | "PENDING_APPROVAL" | "RECEIVED" | "REJECTED" | "SENT";
export type GenerationHistoryQueryVariables = {|
  triggerType?: ?string
|};
export type GenerationHistoryQueryResponse = {|
  +poGenerationLogs: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +triggerType: POGenerationTriggerType,
        +item: ?{|
          +id: string,
          +itemNumber: string,
          +name: string,
        |},
        +order: ?{|
          +id: string,
          +orderNumber: string,
        |},
        +purchaseOrder: ?{|
          +id: string,
          +poNumber: string,
          +status: POStatus,
        |},
        +createdAt: any,
      |}
    |}>
  |}
|};
export type GenerationHistoryQuery = {|
  variables: GenerationHistoryQueryVariables,
  response: GenerationHistoryQueryResponse,
|};
*/


/*
query GenerationHistoryQuery(
  $triggerType: String
) {
  poGenerationLogs(first: 1000, triggerType: $triggerType) {
    edges {
      node {
        id
        triggerType
        item {
          id
          itemNumber
          name
        }
        order {
          id
          orderNumber
        }
        purchaseOrder {
          id
          poNumber
          status
        }
        createdAt
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "triggerType",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "triggerType",
  "variableName": "triggerType"
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "POGenerationLogEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "POGenerationLog",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "triggerType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": null,
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "itemNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "order",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "orderNumber",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "purchaseOrder",
            "storageKey": null,
            "args": null,
            "concreteType": "PurchaseOrder",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "poNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
      }
    ]
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  },
  (v1/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GenerationHistoryQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "poGenerationLogs",
        "name": "__GenerationHistory_poGenerationLogs_connection",
        "storageKey": null,
        "args": [
          (v1/*: any*/)
        ],
        "concreteType": "POGenerationLogConnection",
        "plural": false,
        "selections": (v3/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "GenerationHistoryQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "poGenerationLogs",
        "storageKey": null,
        "args": (v4/*: any*/),
        "concreteType": "POGenerationLogConnection",
        "plural": false,
        "selections": (v3/*: any*/)
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "poGenerationLogs",
        "args": (v4/*: any*/),
        "handle": "connection",
        "key": "GenerationHistory_poGenerationLogs",
        "filters": [
          "triggerType"
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "GenerationHistoryQuery",
    "id": null,
    "text": "query GenerationHistoryQuery(\n  $triggerType: String\n) {\n  poGenerationLogs(first: 1000, triggerType: $triggerType) {\n    edges {\n      node {\n        id\n        triggerType\n        item {\n          id\n          itemNumber\n          name\n        }\n        order {\n          id\n          orderNumber\n        }\n        purchaseOrder {\n          id\n          poNumber\n          status\n        }\n        createdAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "poGenerationLogs"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd31c961a062322ee4ded4300b89c6d1c';
module.exports = node;
